import React from "react"
import {
    Button,
    Input,
    TrashCanIcon
} from "@fluentui/react-northstar"

import { IButtonData } from "./Types"

export interface IButtonFormProps {
    button: IButtonData;
    buttonTextChanged: any;
    buttonUrlChanged: any;
    deleteButtonClick: any;
}

export default function ButtonForm(props: IButtonFormProps) {
    return (
        <React.Fragment key={props.button.id}>
            <Input className="inputField"
                fluid
                value={props.button.title}
                label="Titulo del boton"
                placeholder="Titulo del boton"
                onChange={(event) => props.buttonTextChanged(event, props.button.id)}
                autoComplete="off"
            />
            <Input className="inputField"
                fluid
                value={props.button.url}
                label="URL del boton"
                placeholder="URL del boton"
                onChange={(event) => props.buttonUrlChanged(event, props.button.id)}
                // error={!(state.errorButtonUrlMessage === "")}
                autoComplete="off"
            />
            <Button className="inputButton"
                icon={<TrashCanIcon />}
                iconOnly
                title="Close"
                onClick={() => props.deleteButtonClick(props.button.id)}
            />
        </React.Fragment>
    )
}
